import { assertEx } from '@xyo-network/sdk-xyo-js';
import { RebillyPaymentMethod } from '../../rebilly';
import expiryMonth from './expiryMonth';
import expiryYear from './expiryYear';
const createPaymentTokenParams = (params) => {
    var _a, _b, _c, _d, _e;
    return {
        billingAddress: Object.assign({ firstName: (_a = params.customer) === null || _a === void 0 ? void 0 : _a.firstName, lastName: (_b = params.customer) === null || _b === void 0 ? void 0 : _b.lastName }, params.billing),
        method: RebillyPaymentMethod.card,
        paymentInstrument: {
            cvv: assertEx(params.paymentInfo.cvc, 'Missing cvc'),
            expMonth: expiryMonth((_c = params.paymentInfo.expiry) !== null && _c !== void 0 ? _c : ''),
            expYear: expiryYear((_d = params.paymentInfo.expiry) !== null && _d !== void 0 ? _d : ''),
            pan: (_e = params.paymentInfo.creditcard) !== null && _e !== void 0 ? _e : '',
        },
        sandbox: params.sandbox,
    };
};
export default createPaymentTokenParams;
//# sourceMappingURL=createPaymentTokenParams.js.map